import React, { useState, useEffect } from 'react';
import './App.css';
import CharacterStats from './characterStats.js';
import PatchNotesModal from './components/patchnotes.js';
import { Button } from 'antd';



function App() {
  const [isPatchOpen, setPatchOpen] = useState(false);
  return (
    <div className="App">
      <header className="appHeader">
        <div className="headerFlex">
          <div className="headerLeft">
            <h1 className="headerTitle">CRTOA Stat Calculator</h1>
          </div>
          
          <Button
            className='headerButton'
            onClick={() => setPatchOpen(true)}
          >
            Patch Notes
          </Button>
          <PatchNotesModal isOpen={isPatchOpen} onClose={() => setPatchOpen(false)} />
        </div>
        <div className="headerRight">
          <h3 className="headerCredit">By Kreeperwide</h3>
        </div>
      </header>

      <CharacterStats />

      <footer className="appFooter">
        <div className="footerContent">
          <span>Copyright© {new Date().getFullYear()}</span>
          <div className="footerLinks">
          </div>
        </div>
        <div className="footerDisclaimer">
          <span>The Cookie Run Tower of Adventures stat Calculator is a fan project and unoffiliated with Devsisters</span>
        </div>
        <div className="footerDisclaimer">
          <span>All Artifact, Cookies and stat icons, numerical data, etc, used in Cookie Run: Tower of Adventures are Devsisters Co., Ltd.'s resources and all rights are with Devsisters Co., Ltd.</span>
        </div>
        <div className="footerDisclaimer">
          <span>This site uses the Cookie Run Font
          <a href="https://www.cookierunfont.com/static/download/License_ko_en.pdf" className="fontLicense" title="Cookie Run Font License"> License</a>
          </span>
        </div>
      </footer>

    </div>
  );
}

export default App;
